// src/store/index.js
import { configureStore } from '@reduxjs/toolkit';
import { apiSlice } from './api/apiSlice';
import authReducer from './auth/authSlice';
import cookieConsentReducer from './cookies/cookieConsentSlice';
import uploadReducer from './upload/uploadSlice';
// import websocketService from '../utils/websocketService';

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authReducer,
    cookieConsent: cookieConsentReducer,
    upload: uploadReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
  devTools: process.env.NODE_ENV !== 'production',
});
// websocketService.initialize(store);

// Optional: Setup listeners for token refresh
export const setupListeners = (store) => {
  const token = store.getState().auth.token;
  if (token) {
    // You can set up token refresh logic here
  }
};
